import { useState } from 'react';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import { vscDarkPlus, atomDark, vs } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { docco, gruvboxDark, nnfxDark, xt256 } from 'react-syntax-highlighter/dist/esm/styles/hljs'; // these dont work for some reason
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { FaCopy, FaPaste } from 'react-icons/fa';
// import style from 'react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark';


const Code = ({node, inline, className, children, noCopyButton=false, codeStyle={}, style, ...props}) => {

  const [isCopied, setIsCopied] = useState(false);

  const setCopied = () => {
    setIsCopied(true);
    setTimeout(() => { setIsCopied(false) }, 1000);
  }

  const copyButton = !noCopyButton ? (
    <CopyToClipboard text={children} className='absolute text-white bg-slate-500 text-base rounded-xl px-2 font-mono top-2 right-2 invisible group-hover:visible hover:visible'>
      <button onClick={() => setCopied()}>
        {isCopied
          ? <span title="Copied!">Copied!</span>
          : <span title="Copy to Clipboard">Copy</span>
        }
      </button>
    </CopyToClipboard>
  ) : null ;

  const match = /language-(\w+)/.exec(className || '');
  const customStyle = {
    borderRadius: '20px',
    ...codeStyle
  };
  if ( children == '' ) 
    return null;
  else if ( inline ) {
    // Render inline code
    return <code {...props} className={className}>
      {children}
    </code>
  }
  else if ( match ) {
    // Render code for a specific language
    return (
      <div className={`relative group ${className}`} style={style}>
        { copyButton }
        <SyntaxHighlighter
          {...props}
          children={String(children).replace(/\n\s*$/, '')}
          style={ vscDarkPlus } // vscDarkPlus
          language={match[1]}
          // PreTag="div"
          // wrapLongLines
          showLineNumbers
          customStyle={customStyle}
          codeTagProps={{style: {lineHeight: 'inherit', fontSize: 'inherit'}}}
        />

      </div>
    )
  }
  else {
    // Render code blocks
    return (
      <div className={`relative group ${className}`} style={style}>
        { copyButton }
        <SyntaxHighlighter
          {...props}
          children={String(children).replace(/\n\s*$/, '')}
          style={vscDarkPlus}
          PreTag="div"
          // wrapLongLines
          showLineNumbers
          customStyle={customStyle}
          codeTagProps={{style: {lineHeight: 'inherit', fontSize: 'inherit'}}}
        />
      </div>
    )
  }
}

export default Code